/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Topic } from '../../models/topic';
import { UpdateTopicRequest } from '../../models/update-topic-request';

export interface UpdateTopic$Params {
  id: string;
      body: UpdateTopicRequest
}

export function updateTopic(http: HttpClient, rootUrl: string, params: UpdateTopic$Params, context?: HttpContext): Observable<StrictHttpResponse<Topic>> {
  const rb = new RequestBuilder(rootUrl, updateTopic.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple"});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Topic>;
    })
  );
}

updateTopic.PATH = '/v0/topics/{id}';
